import { pxtorem } from "@/utils/pxtorem";
import AKJS from "@akc/akjs";
import React from "react";
import styles from "./index.module.less";

export default function RulePageIcon({ url, top }: {
  url?: string
  top?: number
}) {
  const toRulePage = () => {
    if (!url) { return; }
    AKJS.action.dispatch("event.page.open", {
      url,
    });
  };
  if (!url) { return null; }
  return <img
    className={styles.rule__absolute}
    src="https://akim-oss.aikucun.com/mshop/8e8a120b7b795a6c5b7428427f5a3e67245d44d4_1731383104974_3.png"
    onClick={toRulePage}
    style={{
      top: pxtorem(top || 102),
    }}
  />;
}